<mat-spinner [diameter]="diameter || 20"></mat-spinner>
